<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            {{ folio ? "Editar" : "Registrar" }} Asistencia
            {{ folio ? `Folio:${folio}` : "" }}
            <router-link :to="{ name: 'Asistencia' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <AsistenciasForm
              :isLoadingPage="isLoadingPage"
              :trabajadores="trabajadores"
              @handledSubmit="(fn) => (handledSubmit = fn)"
              @setData="(fn) => (setData = fn)"
            />

            <div class="mask-edit" v-if="folio && isLoadingPage">
              <div
                class="w-100 d-flex justify-content-center align-items-center"
              >
                <div class="sk-flow flex align-items-center">
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                </div>
              </div>
            </div>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Asistencia' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>


            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton
              v-else
              @click="addAsistenciaItem()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Asistencia"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
      <CModal
        size="sm"
        title="Asistencia"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="closeModal" color="success">Aceptar</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import eventos from "./eventos.json";
import AsistenciasForm from "@/forms/AsistenciasForm.vue";

import "vue-select/dist/vue-select.css";

export default {
  name: "NuevoAsistencia",
  mixins: [validationMixin],
  components: {
    AsistenciasForm,
  },
  validations: {
    fechahora: {
      required,
    },
    evento: {
      required,
    },
    trabajador_id: {
      required,
    },
  },
  data() {
    return {
      folio: this.$route.params.folio,
      eventos,

      isLoading: false,
      isLoadingPage: false,
      trabajadores: [],

      successModal: false,
      warningModal: false,
      nanoid: undefined,
      error: "",
      handledSubmit: () => {},
      setData: () => {},
    };
  },
  created() {
    this.$store.dispatch("getNanoid");
    this.isLoadingPage = true;
    this.actualizarInfo();
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    isValidFechaHora() {
      return !this.$v.fechahora.$invalid;
    },
    isValidTrabajador() {
      return !this.$v.trabajador_id.$invalid;
    },
    isValidEvento() {
      return !this.$v.evento.$invalid;
    },
  },
  watch: {
    ubicacionRaiz() {
      debugger;
      this.actualizarInfo();
    },
  },
  methods: {
    closeModal() {
      this.successModal = false;
      if (this.folio) {
        this.$router.push({ name: "Asistencia" });
      }
    },
    actualizarInfo() {
      console.log(this.filter);

      this.isLoadingPage = true;

      if (!this.ubicacionRaiz?.value) {
        this.warningModal = true;
        this.error = "Favor de selecionar una ubicación raíz";
        this.isLoadingPage = false;
        return;
      }

      const promises = [
        //
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          "with-trashed": true,
          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaiz.value}[[:>:]]`,
              },
              {
                field: "payload->suspendido",
                operator: "=",
                value: false
              },
            ],
          },
        }),
      ];

      Promise.all(promises)
        .then(([trabajadores]) => {
          this.trabajadores = trabajadores.data
            .map((trabajador) => {
              return {
                id: trabajador.id,
                value: trabajador.id,
                label: trabajador.payload.nombre,
                unidad: trabajador.payload.unidad,
                unidad_extra: trabajador.payload.unidad_extra,
                deleted: trabajador.deleted_at !== null,
              };
            })
            .sort((a, b) => a.label.localeCompare(b.label));
        })
        .finally(() => {
          this.isLoadingPage = false;
        });
    },
    async addAsistenciaItem() {
      const form = this.handledSubmit();
      console.log(form);
      if (form.skip) {
        return;
      }
      if (form.error && form.warningModal) {
        this.error = form.error;
        this.warningModal = form.warningModal;
        return;
      }
      if (this.folio) {
        form.folio = this.folio;
        form.payload.encabezado.nanoid = this.nanoid;
      }

      this.$store
        .dispatch(
          this.folio
            ? "customDocumentoRemplazarHTTP"
            : "customDocumentoAddHTTP",
          form
        )
        .then(() => {
          this.currentAlertCounter = 6;
        })
        .catch((rej) => {
          this.error = rej.message;
          this.warningModal = true;
          this.isLoading = false;
          return;
        })

        .finally(() => {
          this.isLoading = false;
          if (!this.warningModal) {
            this.successModal = true;
          }
        });
    },

    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateAsistencia() {
      this.$v.fechahora.$touch();

      this.$v.trabajador_id.$touch();
    },
  },
};
</script>

<style lang="scss" scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
</style>
